import React, { useState, useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import "./Home.css";
import productImage from "../assets/ondaraDevice3.png";
import timerIcon from "../assets/timer.svg";
import moneySquareIcon from "../assets/money-square.svg";
import cubeScanIcon from "../assets/cube-scan.svg";
import logoMain from "../assets/OndaraLogo.webp";
import linkedin from "../assets/linkedin.png";


const Home = () => {
    const [email, setEmail] = useState("");
    const [currentSlide, setCurrentSlide] = useState(1);
    const [confirmationMessage, setConfirmationMessage] = useState("");
  
    const handleEmailSubmit = async (e) => {
      e.preventDefault();
      try {
        await addDoc(collection(db, "waitlist_emails"), {
          email,
          timestamp: new Date(),
        });
        setEmail(""); // Clear the input field
        setConfirmationMessage("Thank you for joining our newsletter!");
        setTimeout(() => setConfirmationMessage(""), 5000); // Hide after 5 seconds
      } catch (error) {
        console.error("Error submitting email to waitlist:", error);
      }
    };

    const scrollToSection = (slideNumber) => {
        const targetSlide = document.querySelector(`[data-slide="${slideNumber}"]`);
        if (targetSlide) {
          targetSlide.scrollIntoView({ behavior: "smooth" });
        }
      };

    useEffect(() => {
    const slides = document.querySelectorAll(".slide");
    const observer = new IntersectionObserver(
        (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
            setCurrentSlide(parseInt(entry.target.dataset.slide, 10));
            }
        });
        },
        { threshold: 0.5 }
    );

    slides.forEach((slide) => observer.observe(slide));
    return () => observer.disconnect();
    }, []);

    const scrollToNext = () => {
    const nextSlide = document.querySelector(`[data-slide="${currentSlide + 1}"]`);
    if (nextSlide) {
        nextSlide.scrollIntoView({ behavior: "smooth" });
    }
    };

  return (
    <div className="home-container">

    {/* Navigation Bar */}
    <nav className="navbar">
      <ul className="nav-list">
        <div className="logo-container" onClick={() => scrollToSection(1)}>
          <img src={logoMain} alt="Logo" className="nav-logo" />
        </div>
        <li className="nav-item active" onClick={() => scrollToSection(4)}>
          Contact
        </li>
      </ul>
    </nav>



      {/* Slide 1: Title */}
      <section className="slide title-slide" data-slide="1">
        {/* Logo at the top */}
        <div className="title-logo-container">
          <img src={logoMain} alt="Ondara Logo" className="hero-logo" />
        </div>

        {/* Split content */}
        <div className="split-content">
          {/* Left side: Hero and Sub-hero */}
          <div className="left-content">
          <h1 className="hero-text accent">
            Direct Microbiome <span className="highlight">Analysis.</span><br />
            <span className="highlight">No Labs, No Delays.</span>
          </h1>
            <p className="sub-hero-text">
            Say goodbye to outdated water testing methods. With <strong className="accent">Computer Vision</strong> Enabled, <strong className="accent">AI-powered</strong> sensors, 
            get accurate, real-time insights into bacterial cultures, algal colonies, and other metrics—no guesswork required.
            </p>
          </div>

          {/* Right side: Product image */}
          <div className="right-content">
            <img src={productImage} alt="Ondara Product" className="product-image" />
          </div>
        </div>
      </section>

      

    {/* Slide 2: Key Benefits */}
    <section className="slide slide-3" data-slide="3">
      <h1 className="slide-2-hero">Why Choose Us?</h1>
      <div className="benefits-container">
        <div className="benefit-card">
          <img src={timerIcon} alt="Save Time" className="benefit-icon" />
          <h3>Save Time</h3>
          <p>
            Get on-the-spot results, no need to ship samples to a lab and wait days for results.
          </p>
        </div>
        <div className="benefit-card">
          <img src={moneySquareIcon} alt="Save Money" className="benefit-icon" />
          <h3>Save Money</h3>
          <p>
            Instead of paying to ship and get lab analysis, get deeper insights for a fraction of the cost.
          </p>
        </div>
        <div className="benefit-card">
          <img src={cubeScanIcon} alt="Improve yield" className="benefit-icon" />
          <h3>Improve Yield</h3>
          <p>
            By getting instant, actionable results, improve shrimp yield by acting fast on harmful disease.
          </p>
        </div>
      </div>
    </section>

    {/* YouTube Video Section */}
    <section className="video-section">
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/1bXVFpu6o1s"
            title="Ondara Product Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </section>

    {/* Slide 3: Contact */}
      <section className="slide slide-4" data-slide="4">
        <div className="contact-box">
          {/* Left Side: Join Our Waitlist */}
          <div className="left-side">
            <h2>Join Our Newsletter</h2>
            <form className="waitlist-form" onSubmit={handleEmailSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="email-input"
              />
              <button type="submit" className="submit-button">
                Join Now
              </button>
            </form>
            {confirmationMessage && (
              <p className="confirmation-message">{confirmationMessage}</p>
            )}
          </div>

          {/* Vertical Divider */}
          <div className="divider"></div>

          {/* Right Side: Contact Us */}
          <div className="right-side">
            <h2>Contact Us</h2>
            <p>Email: <a href="mailto:contact@ondara.io">contact@ondara.io</a></p>
            <p>Phone: <a href="tel:+1 (978) 891-2573">+1 (978) 891-2573</a></p>
            <p>
              Book a Meeting:{" "}
              <a
                href="https://calendly.com/contact-ondara"
                target="_blank"
                rel="noopener noreferrer"
              >
                Schedule a Time
              </a>
            </p>
          </div>
        </div>
      </section>


      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <img src={logoMain} alt="Ondara Logo" className="footer-logo" />
            <p>© 2025 Ondara Solutions. All rights reserved.</p>
          </div>
          <div className="footer-center">
            
          </div>
          <div className="footer-right">
            <p>Connect with us:</p>
            <div className="social-icons">
              <a href="https://linkedin.com/company/ondara-ai/" target="_blank" rel="noopener noreferrer">
                <img src={linkedin} alt="LinkedIn" />
              </a>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default Home;